import { useState } from 'react';
import DeadlineCalculator from '../components/common/DeadlineCalculator';
import CalendarViewer from '../components/diary/CalendarViewer';

// Diary page — Litigate's primary "what's coming up" surface. Combines diary
// events (court dates, deadlines, consultations) with task due dates into one
// consolidated calendar with Month / Week / Day / List views.

export default function Diary() {
  const [showCalc, setShowCalc] = useState(false);

  return (
    <div className="stack">
      <div className="row">
        <h1 className="grow">Diary</h1>
        <button onClick={() => setShowCalc((s) => !s)}>
          {showCalc ? '− Hide deadline calculator' : '📅 Deadline calculator'}
        </button>
      </div>

      {showCalc && <DeadlineCalculator />}

      <CalendarViewer initialView="month" />
    </div>
  );
}
